import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热播专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            精选热门影视专题，深度解读国产影视作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-100 rounded-xl border border-background-200/70 hover:border-accent-300 overflow-hidden transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[16/9] object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      const placeholder = parent.querySelector('.img-placeholder');
                      if (placeholder) (placeholder as HTMLElement).style.display = 'flex';
                    }
                  }}
                />
                <div className="img-placeholder hidden w-full aspect-[16/9] bg-background-200 flex items-center justify-center">
                  <i className="ri-image-line text-3xl text-foreground-400"></i>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">{item.title}</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed flex-1">{item.summary}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap group-hover:gap-2 transition-all">
                  查看详情 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}